import { ApiService } from './ApiService';
import { map, Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { IDictionary } from '@cinetixx/cinetixx-ui';

export abstract class AbstractBaseDictionariesService<T> {

  protected readonly apiService = inject(ApiService);
  protected abstract readonly basePath: string;

  protected getDictionary(type: T): Observable<IDictionary> {
    return this.apiService.get(
      this.basePath,
      new HttpParams().append('dictionary', type.toString())
    ).pipe(map(res => res[0]));
  }
}
